import React from 'react';

export const setConditionDisplayFromUrl = (
  locationSearch: string,
  {
    setKeyword,
    setType,
    setDevice,
    setTestingExperience,
    setOrder,
    setCheckboxStates,
  }: {
    setKeyword: (arg0: string) => void;
    setType: (arg0: 'open' | 'targeting' | 'my_team' | 'limited_open' | 'private' | 'all') => void;
    setDevice: (arg0: 'pc' | 'sp' | 'all') => void;
    setTestingExperience: (arg0: 'except' | 'only' | 'all') => void;
    setOrder: (arg0: 'created_at_desc' | 'created_at_asc' | 'cvr_desc' | 'title_asc') => void;
    setCheckboxStates: React.Dispatch<
      React.SetStateAction<{
        singlePageTest: boolean;
        redirectTest: boolean;
        replaceImage: boolean;
        displayPopup: boolean;
        notActive: boolean;
        competition: boolean;
        interim: boolean;
        paused: boolean;
        archived: boolean;
        editRequest: boolean;
        variation: boolean;
        advertising: boolean;
        closed: boolean;
      }>
    >;
  },
) => {
  const _loationSearch = new URLSearchParams(locationSearch);
  _loationSearch.get('search') && setKeyword(_loationSearch.get('search') ?? '');
  setType(
    ['open', 'targeting', 'my_team', 'limited_open', 'private'].indexOf(_loationSearch.get('type') ?? '') !== -1
      ? (_loationSearch.get('type') as 'open' | 'targeting' | 'my_team' | 'limited_open' | 'private')
      : 'all',
  );
  setDevice(
    ['pc', 'sp'].indexOf(_loationSearch.get('device') ?? '') !== -1
      ? (_loationSearch.get('device') as 'pc' | 'sp')
      : 'all',
  );
  setTestingExperience(
    ['except', 'only'].indexOf(_loationSearch.get('testing_experience') ?? '') !== -1
      ? (_loationSearch.get('testing_experience') as 'except' | 'only')
      : 'all',
  );
  setOrder(
    ['created_at_desc', 'created_at_asc', 'cvr_desc', 'title_asc'].indexOf(_loationSearch.get('order') ?? '') !== -1
      ? (_loationSearch.get('order') as 'created_at_desc' | 'created_at_asc' | 'cvr_desc' | 'title_asc')
      : 'created_at_desc',
  );
  setCheckboxStates({
    singlePageTest: _loationSearch.get('single_page_test') ? true : false,
    redirectTest: _loationSearch.get('redirectTest') ? true : false,
    replaceImage: _loationSearch.get('replaceImage') ? true : false,
    displayPopup: _loationSearch.get('displayPopup') ? true : false,
    notActive: _loationSearch.get('notActive') ? true : false,
    competition: _loationSearch.get('competition') ? true : false,
    interim: _loationSearch.get('interim') ? true : false,
    paused: _loationSearch.get('paused') ? true : false,
    archived: _loationSearch.get('archived') ? true : false,
    editRequest: _loationSearch.get('editRequest') ? true : false,
    variation: _loationSearch.get('variation') ? true : false,
    advertising: _loationSearch.get('advertising') ? true : false,
    closed: _loationSearch.get('closed') ? true : false,
  });
};
